











































import { Component } from 'vue-property-decorator';
import MixinDialog from '@/plugins/podolib/services/helper/mixins/dialog';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TStation } from '@/plugins/podolib/services/entities/EntityStations';

interface IEquipmentsStationDetailsDialog extends MixinDialog {
  _open(station: TEntity<TStation>): void;
}

@Component<IEquipmentsStationDetailsDialog>({
  mounted() {
    this.$pdc.bus!.on('station:details', this._open);
  },
  beforeDestroy() {
    this.$pdc.bus!.off('station:details', this._open);
  },
})
export default class EquipmentsStationDetailsDialog extends MixinDialog {
  station: TEntity<TStation> = null!;

  _open(station: TEntity<TStation>) {
    this.station = station;

    this.open();
  }
}
